export const DefaultUserIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox={viewBox || '0 0 24 24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 6C7.5 3.51472 9.51471 1.5 12 1.5C14.4853 1.5 16.5 3.51472 16.5 6C16.5 8.48528 14.4853 10.5 12 10.5C9.51471 10.5 7.5 8.48528 7.5 6Z"
      fill={fill || '#C1C1C1'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75124 20.1053C3.82858 15.6156 7.49198 12 12 12C16.5081 12 20.1716 15.6157 20.2488 20.1056C20.2539 20.4034 20.0823 20.676 19.8117 20.8002C17.4327 21.8918 14.7865 22.5 12.0003 22.5C9.21386 22.5 6.56743 21.8917 4.18832 20.7999C3.91765 20.6757 3.74611 20.4031 3.75124 20.1053Z"
      fill={fill || '#C1C1C1'}
    />
  </svg>
);
